const configuredGtmId = (process.env.REACT_APP_GTM_ID || '').trim().toUpperCase();

const measurementConfig = {
  gtmId: /^GTM-[A-Z0-9]+$/.test(configuredGtmId) ? configuredGtmId : '',
  enabled: /^GTM-[A-Z0-9]+$/.test(configuredGtmId)
};

export default measurementConfig;
